/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Header_SubtitleInputs */

const es_user_profile_header_subtitle = /** @type {(inputs: User_Profile_Header_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrá tu información personal`)
};

const en_user_profile_header_subtitle = /** @type {(inputs: User_Profile_Header_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your personal information`)
};

/**
* | output |
* | --- |
* | "Manage your personal information" |
*
* @param {User_Profile_Header_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_header_subtitle = /** @type {((inputs?: User_Profile_Header_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Header_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_header_subtitle(inputs)
	return en_user_profile_header_subtitle(inputs)
});
export { user_profile_header_subtitle as "user.profile.header.subtitle" }